import { render, staticRenderFns } from "./lead-collector-success.vue?vue&type=template&id=3722695e&scoped=true"
import script from "./lead-collector-success.vue?vue&type=script&lang=js"
export * from "./lead-collector-success.vue?vue&type=script&lang=js"
import style0 from "./lead-collector-success.vue?vue&type=style&index=0&id=3722695e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3722695e",
  null
  
)

export default component.exports